export const ProductProcessingStatus = {
  None: 0,
  New: 1,
  Updated: 2,
  Processing: 3,
  ReadyForUpload: 4,
  ProcessingFailed: 5,
  UploadCompleted: 6,
  UploadFailed: 7,
  Removed: 8,
  RemoveBgCompleted: 9,
  RemoveBgFailed: 10
}